import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OBannerSplit as OBannerSplitComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OBannerSplitConfig = {
  emptyLabel: 'OBannerSplit',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-banner-split`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OBannerSplit = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-banner-split-comp"
      data-component-name="o-banner-split"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OBannerSplitConfig} {...props}>
        <OBannerSplitComp {...props} />
      </EditableComponent>
    </div>
  );
};
